import { Card } from 'react-bootstrap'
import styles from '../index.module.scss'
import NoPictureImg from '../../../assets/images/noPic.jpg'
import { ReactEventHandler } from 'react'
import { HomePageItem } from '../HomePage'

interface NewsCardProps {
    news: HomePageItem
}

export const NewsCard = (props: NewsCardProps) => {
    const { news } = props

    const handleImageLoadError: ReactEventHandler<HTMLImageElement> = (e) => {
        // @ts-expect-error react cannot see the target is img tag
        e.target.src = NoPictureImg
    }

    return (
        <Card
            className={`${styles.contentBox} ${styles.card} p-3 gap-2`}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
            as={'a'}
            href={news.link}
            target="_blank"
            rel="noreferrer"
        >
            <img
                src={news.data}
                onError={handleImageLoadError}
                alt="news content"
                style={{ borderRadius: '4px' }}
            />
            <Card.Body className="d-flex flex-column gap-3 pb-0 px-0">
                <Card.Title
                    as={'a'}
                    href={news.link}
                    target="_blank"
                    rel="noreferrer"
                    className={`${styles.title} app-color-main`}
                >
                    {news.title}
                </Card.Title>
                <Card.Text className={`${styles.newsDesc} mb-0`}>
                    {news.description}
                </Card.Text>
                <Card.Link
                    className={`${styles.link} p-0`}
                    href={news.link}
                    target="_blank"
                    rel="noreferrer"
                >
                    {news.linkName}
                </Card.Link>
            </Card.Body>
        </Card>
    )
}